import React, { useEffect } from "react"; // <-- add useEffect here
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaCheckCircle, FaTools, FaNetworkWired, FaServer, FaCogs, FaShieldAlt, FaArrowAltCircleRight } from "react-icons/fa";
import "aos/dist/aos.css";
import "../styles/Telecom.css"; // Custom styles

const TelecomSupport = () => {
  useEffect(() => {
      window.scrollTo(0, 0); // <-- This forces scroll to top
    }, []);
  
  return (
    <div className="telecom-support-section text-dark"
     style={{ backgroundColor: "#f0f7ff" }}>
      <Container fluid className="py-5">
        <Container data-aos="fade-up">
          <Row className="align-items-center">
            <Col md={6} data-aos="fade-right">
              <h3 className="fw-bold mb-3">Comprehensive Telecom Support</h3>
              <p className="lead">
                Telecom Infrastructure Support Services are essential for the maintenance and development of modern communication systems, including cellular towers, fiber-optics, and data centers.
              </p>
              <ul className="list-unstyled check-list">
                <li><FaCheckCircle className="me-2 text-success" /> Data centers, fiber-optic, and system maintenance</li>
                <li><FaCheckCircle className="me-2 text-success" /> Support for SUN/Solaris, RedHat, Cisco, HP, IBM</li>
                <li><FaCheckCircle className="me-2 text-success" /> OS and hardware configuration</li>
              </ul>
            </Col>
            <Col md={6} data-aos="fade-left">
              <video
                src="/videos/Telecom.mp4"
                className="network-video mt-4"
                autoPlay
                loop
                muted
                playsInline
              />
            </Col>
          </Row>

          {/* <div className="divider my-5"></div> */}

          <h4 className="fw-bold text-center mb-4 key-services-section">Key Services</h4>
          <Row className="g-4">
            <Col md={4} data-aos="zoom-in">
              <Card className="service-card h-100">
                <Card.Body>
                  <FaTools className="icon" />
                  <Card.Title>End of Life Hardware Maintenance</Card.Title>
                  <Card.Text>
                    We maintain and deploy legacy systems to ensure continued operation even when vendor support ends.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} data-aos="zoom-in" data-aos-delay="100">
              <Card className="service-card h-100">
                <Card.Body>
                  <FaNetworkWired className="icon" />
                  <Card.Title>Network Design and Planning</Card.Title>
                  <Card.Text>
                    Plan future-ready networks that are scalable and integrated with emerging technologies.
                  </Card.Text>
                  {/* <a href="#network-design" className="read-more">
                    Read more <FaArrowAltCircleRight className="ms-1" />
                  </a> */}
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} data-aos="zoom-in" data-aos-delay="200">
              <Card className="service-card h-100">
                <Card.Body>
                  <FaServer className="icon" />
                  <Card.Title>Installation and Deployment</Card.Title>
                  <Card.Text>
                    Professional setup of telecom infrastructure with safety and industry compliance.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} data-aos="zoom-in">
              <Card className="service-card h-100">
                <Card.Body>
                  <FaCogs className="icon" />
                  <Card.Title>Maintenance and Support</Card.Title>
                  <Card.Text>
                    Routine checks and 24/7 issue resolution to ensure optimal performance and uptime.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} data-aos="zoom-in" data-aos-delay="100">
              <Card className="service-card h-100">
                <Card.Body>
                  <FaShieldAlt className="icon" />
                  <Card.Title>Site Management</Card.Title>
                  <Card.Text>
                    Full management of telecom sites including compliance, logistics, and security.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} data-aos="zoom-in" data-aos-delay="200">
              <Card className="service-card h-100">
                <Card.Body>
                  <FaCogs className="icon" />
                  <Card.Title>Upgrades and Optimization</Card.Title>
                  <Card.Text>
                    Identify areas for improvement and implement upgrades to boost service and performance.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* <div className="divider my-5"></div> */}

          <h4 className="fw-bold text-center why-choose-heading why-choose-section">Why Choose Us?</h4>
          {/* <ul className="list-unstyled row check-list-lg justify-content-center">
            <li className="col-md-4" data-aos="fade-up"><FaCheckCircle className="me-2 text-success" /> Seasoned professionals & domain expertise</li>
            <li className="col-md-4" data-aos="fade-up" data-aos-delay="100"><FaCheckCircle className="me-2 text-success" /> Innovative, modern telecom practices</li>
            <li className="col-md-4" data-aos="fade-up" data-aos-delay="200"><FaCheckCircle className="me-2 text-success" /> 24/7 proactive monitoring and support</li>
            <li className="col-md-4" data-aos="fade-up"><FaCheckCircle className="me-2 text-success" /> Tailored, client-first solutions</li>
            <li className="col-md-4" data-aos="fade-up" data-aos-delay="100"><FaCheckCircle className="me-2 text-success" /> Cost-effective and scalable infrastructure</li>
            <li className="col-md-4" data-aos="fade-up" data-aos-delay="200"><FaCheckCircle className="me-2 text-success" /> Proven results and high client satisfaction</li>
          </ul> */}
          <Row className="justify-content-center">
  {[
    "Seasoned professionals & domain expertise",
    "Innovative, modern telecom practices",
    "24/7 proactive monitoring and support",
    "Tailored, client-first solutions",
    "Cost-effective and scalable infrastructure",
    "Proven results and high client satisfaction",
  ].map((item, index) => (
    <Col md={4} sm={6} xs={12} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
      <div className="why-choose-box">
        <FaCheckCircle className="why-choose-icon" />
        <span className="why-choose-text">{item}</span>
      </div>
    </Col>
  ))}
</Row>

          <div className="text-center mt-5" data-aos="zoom-in">
            <Button variant="primary" href="/contact" className="cta-button">
              Contact Us 
            </Button>
          </div>
        </Container>
      </Container>
    </div>
  );
};

export default TelecomSupport;
